import { Box, Typography } from '@mui/material';

export const JsonBlock = ({ title, value }) => {
  const isEmpty = value === null || value === undefined;
  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>{title}</Typography>
      <pre
        style={{
          margin: 0,
          padding: 8,
          background: '#f5f5f5',
          borderRadius: 4,
          overflow: 'auto',
          maxHeight: 300,
          fontSize: 12
        }}
      >
        {isEmpty ? '—' : JSON.stringify(value, null, 2)}
      </pre>
    </Box>
  );
};
